import { Button } from '@/components/ui/Button';
import { Skeleton } from '@/components/ui/Skeleton';
import { useAdminOrganisationDetail } from '@/hooks/useAdminOrganisations';
import { ArrowLeft } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import { OrgActionsMenu } from '../components/OrgActionsMenu';
import { OrgInfoCard } from '../components/OrgInfoCard';
import { OrgMembersCard } from '../components/OrgMembersCard';
import { OrgDomainsCard } from '../components/OrgDomainsCard';
import { OrgBillingCard } from '../components/OrgBillingCard';

export function OrganisationDetailPage() {
  const { uuid } = useParams<{ uuid: string }>();
  const navigate = useNavigate();
  const { data: response, isLoading } = useAdminOrganisationDetail(uuid);

  // API returns { data: { ...org } } or directly { ...org }
  const org = (response as any)?.data ?? response;

  if (isLoading) {
    return <div className="space-y-4"><Skeleton className="h-8 w-48" /><Skeleton className="h-64" /></div>;
  }
  if (!org || !org.uuid) {
    return <div className="text-center py-12"><p className="text-neutral-600 dark:text-neutral-400">Organisation introuvable</p></div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Button variant="ghost" size="sm" icon={<ArrowLeft className="h-4 w-4" />} onClick={() => navigate('/organisations')} />
          <h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">{org.name}</h1>
        </div>
        <OrgActionsMenu orgUuid={org.uuid} status={org.deletedAt ? 'suspended' : 'active'} />
      </div>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        <OrgInfoCard org={org} />
        <div className="lg:col-span-2 space-y-4">
          <OrgMembersCard org={org} />
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <OrgDomainsCard org={org} />
            <OrgBillingCard org={org} />
          </div>
        </div>
      </div>
    </div>
  );
}
